import {
    FETCH_TRANSFER_WITH_PERCENTAGE,
    LIST_TRANSFER_WITH_PERCENTAGE
} from "./types";

const init = {
    isLoading: false,
    data: null,
    filter: {}
};
export default (state = init, {type, payload}) => {
    switch (type) {
        case FETCH_TRANSFER_WITH_PERCENTAGE:
            return {
                ...state,
                filter: payload,
                isLoading: true
            };
        case LIST_TRANSFER_WITH_PERCENTAGE:
            return {
                ...state,
                isLoading: false,
                data: payload.data
            };
        default:
            return state

    }
}